import React, { Component } from "react";
import Fact from "./fact";
import EzSlider from "../../ezSlider";
import Row from "../../containers/row";
import TitleBar from "../../titleBar";
import Gutters from "../../config/gutters";
import gutter from "../../config/vars";
class Factoid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      factoid: [],
      config: [],
      nodeid: [],
      loading: true,
      error: false
    };
  }

  /* */
  componentDidMount() {
    const url =
      "https://www.uvm.edu/content/shared/api/v1.0/factoids?filter[display]=" +
      this.props.factoid;
    fetch(url)
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({
          factoid: data.data
        });
      })
      .catch(error => this.setState({ loading: false, error }));
  }

  /* */
  renderItems() {
    return this.state.factoid.map(item =>
      <div key={item.id} className="Slide">
        <Fact item={item} attributes="blue" />
      </div>
    );
  }
  /* */
  render() {
    const titleStyles = this.props.blockStyle.attributes;
    const titleClassName = this.props.blockStyle.name.replace(" ", "-");
    const margin =
      Gutters.spacings[this.props.blockStyle.top] +
      "px auto " +
      Gutters.spacings[this.props.blockStyle.btm] +
      "px auto";
    //const padding=Gutters.spacings[this.props.blockStyle.inner_top]+"px auto "+Gutters.spacings[this.props.blockStyle._btmbtm]+"px auto";
    const padding =
      Gutters.spacings[this.props.blockStyle.inner_top] +
      "px 24px " +
      Gutters.spacings[this.props.blockStyle.inner_btm] +
      "px 24px";
    if (this.state.config) {
      return (
        <div
          className="factoidRow"
          style={{
            backgroundColor: this.props.blockStyle.attributes.field_color_1,
            height: 400,
            display: "block",
            float: "left",
            margin: margin,
            width: "100%",
            position: "relative",
            padding: padding
          }}
        >
          {this.props.row.field_boolean_2 !== "0"
            ? <TitleBar
                className={titleClassName}
                bgc={titleStyles.field_bgcolor_1}
                font={titleStyles.field_font_1}
                max="19"
                min="16"
                container="Left"
                tag="p"
              >
                {this.props.row.field_text_1}
              </TitleBar>
            : ""}
          <div
            className="factoidBox"
            style={{
              height: 400,
              overflow: "hidden",
              margin: margin
            }}
          >
            <Row
              bgc="transparent"
              className="innerRow"
              margin="48px 0px 24px"
              display="flex"
            >
              {window.innerWidth > 899
                ? <EzSlider
                    slides={this.renderItems()}
                    navTop="50"
                    navColor="#9b9b9b"
                    hoverColor="rgb(68, 68, 68)"
                    width="360px"
                    padding={"0 " + gutter}
                    borderRight="true"
                    instanceID={this.props.row.item_id}
                    settings={{
                      className: "center",
                      centerMode: true,
                      centerPadding: "20px",
                      arrowNav: {
                        useArrow: true,
                        arrowStyles: {
                          position: "absolute",
                          zIndex: "4444"
                        },
                        right: "10px",
                        left: "10px",
                        top: "120px"
                      },
                      dots: false,
                      infinite: true,
                      speed: 500,
                      slidesToShow: 3,
                      slidesToScroll: 3,
                      initialSlide: 0,
                      swipeToSlide: true
                    }}
                  />
                : <EzSlider
                    slides={this.renderItems()}
                    navTop="50"
                    navColor="#444"
                    padding="0"
                    ulStyles={{
                      padding: 0,
                      margin: 0
                    }}
                    slideOuterStyle={{
                      position: "absolute",
                      left: "50%",
                      transform: "translate(-50%)",
                      width: "75%"
                    }}
                    borderRight="true"
                    settings={{
                      isFull: false,
                      arrowNav: {
                        useArrow: true,
                        arrowStyles: {
                          position: "absolute",
                          zIndex: "4444"
                        },
                        right: "10px",
                        left: "10px",
                        top: "120px"
                      },
                      dots: false,
                      infinite: true,
                      speed: 500,
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      initialSlide: 0,
                      swipeToSlide: true
                    }}
                  />}
            </Row>
          </div>
        </div>
      );
    } else return <p>Loading...</p>;
  }
}

export default Factoid;
